import { createFileRoute } from '@tanstack/react-router';
import { fallback, zodValidator } from '@tanstack/zod-adapter';
import { AssignedGroupShipments } from '@uturn/portal/modules/shipments';
import {
	GroupedShipmentsSearchSchema,
	SHIPMENTS_SEARCH_DEFAULT_STATUSES_ASSIGNED,
	ShipmentsSearchStatusesSchema,
} from '@uturn/portal/router/schema/shipments-search';

const AssignedGroupedShipmentsSearchSchema =
	GroupedShipmentsSearchSchema.extend({
		'filter.statuses': fallback(
			ShipmentsSearchStatusesSchema.array(),
			SHIPMENTS_SEARCH_DEFAULT_STATUSES_ASSIGNED,
		).default(SHIPMENTS_SEARCH_DEFAULT_STATUSES_ASSIGNED),
	})

export const Route = createFileRoute(
	'/_protected/shipments/groups/$groupId/assigned',
)({
	component: AssignedGroupShipments,
	validateSearch: zodValidator(AssignedGroupedShipmentsSearchSchema),
});
